var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (i18n, image, paragraphs, undefined) {
jade_mixins["image"] = jade_interp = function(imageUrl, klass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<img" + (jade.attr("src", imageUrl, true, false)) + (jade.cls([klass], [true])) + "/>");
};
buf.push("<div class=\"content-fill content-fit block-lg text-center\"><div class=\"game-description\"><div class=\"block-md\">");
jade_mixins["image"](image,'game-image');
buf.push("</div><div class=\"text-md\">");
// iterate paragraphs
;(function(){
  var $$obj = paragraphs;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var p = $$obj[$index];

buf.push("<p>" + (null == (jade_interp = p) ? "" : jade_interp) + "</p>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var p = $$obj[$index];

buf.push("<p>" + (null == (jade_interp = p) ? "" : jade_interp) + "</p>");
    }

  }
}).call(this);

buf.push("</div><div class=\"block-v-md\"><div class=\"btn btn-muted btn-continue\">" + (jade.escape((jade_interp = i18n("buttons.continue")) == null ? '' : jade_interp)) + "</div></div></div></div>");}.call(this,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"image" in locals_for_with?locals_for_with.image:typeof image!=="undefined"?image:undefined,"paragraphs" in locals_for_with?locals_for_with.paragraphs:typeof paragraphs!=="undefined"?paragraphs:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}